import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.socialProgramProcessingTransactions
)

export const selectSocialProgramProcessingTransactionsError = createSelector(
    baseSelector,
    (state) => state.error
)
export const selectSocialProgramProcessingTransactions = createSelector(
    baseSelector,
    (state) => state.transactions
)
export const selectSocialProgramProcessingTransactionsLoading = createSelector(
    baseSelector,
    (state) => state.isLoading
)
export const selectSocialProgramProcessingTransactionsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isFirstLoad
)
export const selectSocialProgramProcessingTransactionsCurrentPage = createSelector(
    baseSelector,
    (state) => state.page
)
export const selectSocialProgramProcessingTransactionsStartDate = createSelector(
    baseSelector,
    (state) => state.startDate
)
export const selectSocialProgramProcessingTransactionsEndDate = createSelector(
    baseSelector,
    (state) => state.endDate
)
export const selectSocialProgramProcessingTransactionsBonus = createSelector(
    baseSelector,
    (state) => state.bonusId
)
